import {DomainStore} from 'shared/store';
import {observable, action, computed} from 'mobx';
import {endpoints, types} from 'main/tools';
import PublicInterviewInvite from 'main/stores/ats/PublicInterviewInvite';
import {dateStringInZone, formatTimeInZone} from 'shared/tools/dates';
import _ from 'lodash';
import moment from 'moment';

class ScheduleInterviewState {
  store = new DomainStore();

  @observable interviewInvite;
  @observable selectedDate;
  @observable selectedSlot;

  @observable timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  @action async load() {
    const token = new URLSearchParams(location.search).get('token');

    await this.store._compose([
      endpoints.INTERVIEW_INVITE.PUBLIC.with(token)
    ]);
    this.interviewInvite = new PublicInterviewInvite(this.store._getSingle(types.INTERVIEW_INVITE));
  }

  @action setTimeZone(timeZone) {
    this.timeZone = timeZone;
    this.selectedSlot = null;
    if (!this.isDateBookable(this.selectedDate)) {
      this.selectedDate = null;
    }
  }

  @action setSelectedDate(date) {
    this.selectedDate = date;
    this.selectedSlot = null;
  }

  @action setSelectedSlot(slot) {
    this.selectedSlot = slot;
  }

  isDateBookable(date) {
    return this.slotsForDate(date).length > 0;
  }

  slotsForDate(date) {
    const targetDate = moment(date).format('YYYY-MM-DD');
    return _.get(this.bookableSlotsInTimeZone, targetDate, []);
  }

  @computed get bookableSlotsInTimeZone() {
    const slotsInTimeZone = this.interviewInvite.bookableSlots.map((slot) => ({
      ...slot,
      day: dateStringInZone(slot.startTime, this.timeZone),
      startTime: formatTimeInZone(slot.startTime, this.timeZone)
    }));

    return _.groupBy(slotsInTimeZone, 'day');
  }

  @computed get firstAvailableDate() {
    const days = Object.keys(this.bookableSlotsInTimeZone);

    if (days.length === 0) return null;

    return moment(days[0]).toDate();
  }
}

export default ScheduleInterviewState;
